import React, { Fragment, useState } from "react"
import { v4 as uuidv4 } from "uuid"
import { useLocation, useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button } from "components"
import { doesItemExistInCart, isDirectionLtr, isStockLimited } from "utils"
import KioskFoodSuccessModal from "./KioskFoodSuccessModal"
import KioskFoodSpecifications from "./KioskFoodSpecifications"
import { addOrderItem, updateOrderItem } from "@redux"
import { isCustomBuilderComplete } from "./KioskFoodSpecifications/customBuilder"
import classes from "./KioskFoodFooter.module.scss"

const KioskFoodFooter = props => {
  const { food, quantity, selectedOption } = props

  const dispatch = useDispatch()

  const history = useHistory()

  const location = useLocation()

  const [t, i18n] = useTranslation()

  const foodTaxesMap =
    useSelector(state => state.foodTaxesMap)

  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [openFoodSpecificationsModal, setOpenFoodSpecificationsModal] = useState(false)
  const [selectedSpecificationItems, setSelectedSpecificationItems] = useState([])

  const hasCustomBuilder =
    !!food.customBuilder?.enabled &&
    Array.isArray(food.customBuilder?.steps) &&
    food.customBuilder.steps.length > 0

  const customBuilderComplete =
    isCustomBuilderComplete(
      food.customBuilder,
      selectedSpecificationItems
    )

  const handleGoBack = () => {
    !!location.key
      ? history.goBack()
      : history.push("/kiosk-foods")
  }

  const createOrderItemData = (food, newOrderItemId) => {
    const foodTaxItems = []

    food.taxItemIds.forEach(taxItemId => {
      const tax = foodTaxesMap[taxItemId]

      if (!tax) return

      foodTaxItems.push(tax)
    })

    const newOrderItem = {
      orderItemId: newOrderItemId,
      quantity,
      branchId: selectedOption.branchId,
      foodName: food.name,
      foodNameEn: food.nameEn,
      foodNameAr: food.nameAr,
      unit: food.unit,
      optionName: selectedOption.name,
      optionNameEn: selectedOption.nameEn,
      optionNameAr: selectedOption.nameAr,
      isAvailable: true,
      isSimple: food.options.length === 1,
      foodId: food._id,
      specificationItems: selectedSpecificationItems,
      customBuilder: food.customBuilder,
      optionId: selectedOption._id,
      salePrice: selectedOption.salePrice,
      taxInclusive: food.taxInclusive,
      stockManagement: selectedOption.stockManagement,
      availableQuantity: selectedOption.availableQuantity,
      taxItems: foodTaxItems,
      foodImageCover: food.imageCover,
      systemDiscount: 0
    }

    return newOrderItem
  }

  const handleChangeOrderItem = (targetOrderItem) => {
    const changedOrderItem = {
      specificationItems: targetOrderItem.specificationItems,
      quantity: targetOrderItem.quantity
    }

    dispatch(
      updateOrderItem(
        changedOrderItem,
        targetOrderItem.orderItemId
      )
    )
  }

  const handleAddOrderItem = (newOrderItem) => {
    dispatch(
      addOrderItem(newOrderItem)
    )
  }

  const handleCart = () => {
    const newOrderItemId = uuidv4()

    const newOrderItem =
      createOrderItemData(food, newOrderItemId)

    const showToast = false

    const increasedQuantity = quantity

    const limitedStock =
      isStockLimited(
        newOrderItem,
        increasedQuantity,
        showToast
      )

    if (limitedStock) return

    const targetOrderItem =
      doesItemExistInCart(newOrderItem)

    const isItemInCart = !!targetOrderItem

    isItemInCart
      ? handleChangeOrderItem(targetOrderItem)
      : handleAddOrderItem(newOrderItem)
  }

  const handleClick = () => {
    if (hasCustomBuilder || food.specificationIds.length > 0) {
      setSelectedSpecificationItems([])

      return setOpenFoodSpecificationsModal(true)
    }

    handleCart()

    setShowSuccessModal(true)
  }

  const handleConfirm = () => {
    if (hasCustomBuilder && !customBuilderComplete) return

    handleCart()

    setOpenFoodSpecificationsModal(false)

    setShowSuccessModal(true)
  }

  const isSoldout =
    !!selectedOption
      ?
      (
        selectedOption.outOfStock ||
        (
          selectedOption.stockManagement &&
          selectedOption.availableQuantity <= 0
        )
      )
      :
      true

  const isLtr =
    isDirectionLtr(i18n.language)

  return (
    <Fragment>
      <div className={classes["container"]}>
        <button
          onClick={handleGoBack}
          className={clsx(
            classes["go-back"],
            isLtr && classes["go-back-ltr"]
          )}
        >
          {t("برگرد_به_صفحه_ی_قبل")}
        </button>

        <Button
          disabled={isSoldout}
          className={classes["add"]}
          onClick={handleClick}
        >
          {isSoldout
            ? t("ناموجود")
            : hasCustomBuilder
              ? "سفارشی سازی و افزودن"
              : t("افزودن_به_سفارش")
          }
        </Button>
      </div>

      <KioskFoodSpecifications
        food={food}
        quantity={quantity}
        hasCustomBuilder={hasCustomBuilder}
        selectedOption={selectedOption}
        onConfirm={handleConfirm}
        openFoodSpecificationsModal={openFoodSpecificationsModal}
        setOpenFoodSpecificationsModal={setOpenFoodSpecificationsModal}
        selectedSpecificationItems={selectedSpecificationItems}
        setSelectedSpecificationItems={setSelectedSpecificationItems}
      />

      <KioskFoodSuccessModal
        showSuccessModal={showSuccessModal}
        setShowSuccessModal={setShowSuccessModal}
      />
    </Fragment>
  )
}

export default KioskFoodFooter
